import { configureStore } from '@reduxjs/toolkit';
import partnerReducer from './slices/partnerSlice';
import screenReducer from './slices/screenSlice';
import showReducer from './slices/showSlice';
import bookingReducer from './slices/bookingSlice';
import analyticsReducer from './slices/analyticsSlice';
import subscriptionReducer from './slices/subscriptionSlice';

const store = configureStore({
  reducer: {
    partner: partnerReducer,
    screen: screenReducer,
    show: showReducer,
    booking: bookingReducer,
    analytics: analyticsReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['partner/setPartner'],
        ignoredPaths: ['partner.partner'],
      },
    }),
});

export default store;
